<template>
<div>
  <div id="loading-circle-wrapper">
    <div id="loading-circle"></div>
  </div>
</div>
</template>
<script>
export default {
  name: "LoadingCircle"
}
</script>
<style lang="less" scoped>
@keyframes row {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(360deg);
  }
}
#loading-circle-wrapper {
  animation: row 3s linear infinite;
}
#loading-circle {
  position: relative;
  border: 1px solid transparent;
  border-radius: 50%;
  background: #fff;
  padding: 10px;
  &::before {
    content: '';
    display: block;
    position: absolute;
    height: 16px;
    width: 6px;
    background-color: #fff;
  }
  &::after {
    position: absolute;
    top: -4px;
    bottom: -4px;
    left: -4px;
    right: -4px;
    background: linear-gradient(#16b25f, #05a8cb);
    content: '';
    z-index: -1;
    border-radius: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LoadingCircle.vue